"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const date_fns_1 = require("date-fns");
const Pagination_1 = __importDefault(require("@mui/material/Pagination"));
const DateRange_1 = __importDefault(require("@mui/icons-material/DateRange"));
const react_router_dom_1 = require("react-router-dom");
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const helpers_1 = require("../../../common/helpers/helpers");
const modalEnums_1 = __importDefault(require("../../../common/modalEnums"));
const useEventListener_1 = __importDefault(require("../../../common/helpers/Hooks/useEventListener"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const services_1 = require("../../../common/services");
const ActivityListItem_1 = __importDefault(require("../Other/ActivityListItem"));
const globalVariables_1 = require("../../../common/globalVariables");
const DateFilter_1 = __importDefault(require("../../../common/components/Filters/DateFilter"));
const BubbleFilter_1 = require("../../../common/components/Filters/BubbleFilter");
const useUrlParams_1 = require("../../behaviours/useUrlParams");
const ActivityListWrapper = styled_components_1.default.div `
  width: 100%;
  background: #fff;
`;
const ActivityListContainer = styled_components_1.default.div `
  max-width: ${props => props.contentMaxWidth}px;
  margin: 0 auto;
  padding: 20px 16px 40px;

  @media (max-width: 480px) {
    padding: 20px 16px;
  }
`;
const Filters = styled_components_1.default.div `
  position: sticky;
  top: 60px;
  background: #fff;
  z-index: 3;

  &.border-bottom {
    border-bottom: solid 1px #e7e8e7;
  }

  .filters-content {
    margin: 0 auto;
  }

  .interest-filter-list {
    max-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_CONTAINER}px;
    margin: 0 auto;
  }

  .date-filter-list {
    width: 100%;
    padding: 0 !important;
    margin: 0 auto;

    .carousel-wrapper {
      position: relative;
      max-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_CONTAINER}px;
      margin: 0 auto;
    }
  }
`;
const LoaderWrapper = styled_components_1.default.div `
  position: relative;
  padding: 10px 0;

  > div {
    position: relative;
    display: block;
    left: 0;
    top: 0;
    margin: 0 auto;
  }
`;
const PaginationWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;
const NoActivitiesWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 10vmin;

  .date-icon {
    font-size: 75px;
    padding: 15px;
    border-radius: 50%;
    background-color: #e1e6e8;
  }

  p {
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0.5px;
    color: #737373;
  }
`;
const BATCH_SIZE = 25;
const Activities = ({ timezone, currentLocale, userData, filters, conventionCode, activities, activitiesWereFetched, baseUrl, }) => {
    const activitiesRef = (0, react_1.useRef)([]);
    const { disableParticipateButton, disabledParticipateButtonText } = (0, useUrlParams_1.useUrlParams)();
    const [displayedActivities, setDisplayedActivities] = (0, react_1.useState)([]);
    const [currentPage, setCurrentPage] = (0, react_1.useState)(0);
    const [selectedFilter, setSelectedFilter] = (0, react_1.useState)({
        id: 0,
        interests: [],
        name: '',
        iconUrl: null,
    });
    const [dateFilter, setDateFilter] = (0, react_1.useState)(null);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [isScroll, setIsScroll] = (0, react_1.useState)(false);
    const [filteredTotal, setFilteredTotal] = (0, react_1.useState)(0);
    const mockActivitiesCall = (dateFilter1, selectedFilter1, currentPage1) => {
        if (activitiesRef.current.length === 0) {
            return null;
        }
        const batch = activitiesRef.current
            .filter(activity => {
            if (selectedFilter1.interests.length === 0) {
                return true;
            }
            return doesActivityBelongToInterest(activity, selectedFilter1);
        })
            .filter((activity) => {
            if (!dateFilter1) {
                return true;
            }
            return (0, date_fns_1.isSameDay)(new Date(activity.start), new Date(dateFilter1));
        });
        setFilteredTotal(batch.length);
        const slicedBatch = batch.slice(currentPage1 * BATCH_SIZE, (currentPage1 + 1) * BATCH_SIZE);
        return slicedBatch;
    };
    const fetchNextBatch = (page) => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        const activityBatch = mockActivitiesCall(dateFilter, selectedFilter, page);
        let availabilityBatch = [];
        if (activityBatch === null) {
            setIsLoading(false);
            return;
        }
        const bookableActivityIds = activityBatch
            .filter((activity) => activity.bookable)
            .map((activity) => `${activity.contentId}`);
        if (bookableActivityIds.length > 0) {
            availabilityBatch = yield services_1.apiService.getAvailabilities(currentLocale, userData.token, bookableActivityIds);
        }
        const batchWithAvailabilities = activityBatch.map((activity) => {
            const matchingAvailability = availabilityBatch.find((availability) => availability.messageId === activity.contentId);
            return Object.assign({}, activity, {
                availability: matchingAvailability,
            });
        });
        // use a timeout to trigger the loading animation every time this action is done so the list will scroll to the start of the page
        setTimeout(() => {
            setIsLoading(false);
        }, 0);
        setDisplayedActivities(batchWithAvailabilities);
    });
    const updateActivityAfterBooking = activityId => {
        services_1.apiService.getActivity(currentLocale, userData.token, activityId).then(updatedActivityDetail => {
            const indexOfActivity = displayedActivities.findIndex((activity) => activity.contentId === activityId);
            const updatedActivities = [
                ...displayedActivities.slice(0, indexOfActivity),
                updatedActivityDetail,
                ...displayedActivities.slice(indexOfActivity + 1),
            ];
            setDisplayedActivities(updatedActivities);
        });
    };
    const handleScroll = () => {
        if (window.scrollY > 0) {
            return setIsScroll(true);
        }
        return setIsScroll(false);
    };
    (0, useEventListener_1.default)('activityWasBooked', (activityId) => {
        updateActivityAfterBooking(activityId.detail.activityId);
    });
    (0, useEventListener_1.default)('scroll', () => {
        handleScroll();
    });
    (0, react_1.useEffect)(() => {
        if (conventionCode) {
            services_1.apiService.getConventionActivities(currentLocale, userData.token, conventionCode).then(data => {
                activitiesRef.current = data;
                fetchNextBatch(0);
            });
            return;
        }
        const contentFullId = `-${window.location.pathname.split('--').pop()}`;
        const content = { contentId: contentFullId };
        if (!contentFullId.includes('/activities')) {
            helpers_1.Helpers.openModal(modalEnums_1.default.ACTIVITY_DETAILS, {
                content,
                redirectOnClose: `${baseUrl}/activities`,
            });
        }
        // i'll leave this part comented because we plan on modifying the way we fetch activities and this code will be usefull
        // apiService.getActivities( { locale: currentLocale, userToken: userData.token } )
        //     .then( ( data ) => {
        //         activitiesRef.current = data;
        //         fetchNextBatch( 0 );
        //     } );
    }, []);
    (0, react_1.useEffect)(() => {
        if (!conventionCode && activities.length > 0) {
            activitiesRef.current = activities;
        }
        if (activitiesRef.current.length > 0) {
            const pageToFetch = currentPage || 0;
            fetchNextBatch(pageToFetch);
            return;
        }
        if (!conventionCode && activitiesWereFetched && activities.length === 0) {
            setIsLoading(false);
        }
    }, [activities, currentPage, dateFilter, selectedFilter, conventionCode, activitiesWereFetched]);
    const filteredActivitiesWithDateTitles = groupActivitiesByDate(displayedActivities, timezone, currentLocale);
    const noActivitiesAtAll = !conventionCode && activitiesWereFetched && activities.length === 0;
    const noFilteredActivities = !conventionCode &&
        activitiesWereFetched &&
        activities.length > 0 &&
        !isLoading &&
        filteredActivitiesWithDateTitles.length === 0;
    const onFilterSelect = newFilter => {
        if (newFilter.id === selectedFilter.id) {
            // wipe filter if the currently selected filter is clicked again
            setSelectedFilter({
                id: 0,
                interests: [],
                name: '',
                iconUrl: null,
            });
        }
        else {
            setSelectedFilter(newFilter);
        }
        setCurrentPage(0);
    };
    const onDateFilterSelect = date => {
        setCurrentPage(0);
        setDateFilter(date);
    };
    const dateFilterEndDate = activitiesRef.current.length > 0 ? activitiesRef.current[activitiesRef.current.length - 1].start : new Date();
    let numberOfDaysToBeDisplayed = Math.ceil(helpers_1.Helpers.getDaysBetweenDates(new Date(), new Date(dateFilterEndDate)));
    if (numberOfDaysToBeDisplayed <= 0) {
        numberOfDaysToBeDisplayed = 1;
    }
    function doesActivityBelongToInterest(activity, selectedInterest) {
        if (!selectedInterest) {
            return true;
        }
        return activity.interestIds.filter(interest => selectedInterest.interests.indexOf(interest) !== -1).length > 0;
    }
    function buildRows(activities) {
        return activities.map(activity => row(activity));
    }
    function row(activity) {
        const rowElement = activity.isDateTitle ? (react_1.default.createElement(Typography_1.default, { key: activity.displayText, variant: "h6" },
            ' ',
            activity.displayText,
            ' ')) : (react_1.default.createElement(ActivityListItem_1.default, { key: activity.contentId, content: activity, withLazyLoad: false, disableParticipateButton: disableParticipateButton, disabledParticipateButtonText: disabledParticipateButtonText }));
        return rowElement;
    }
    function groupActivitiesByDate(activities, timezone, currentLocale) {
        const daysDisplayed = [];
        const groupedActivities = [];
        activities.map(activity => {
            const formatOptions = {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
            };
            const date = helpers_1.Helpers.convertDateToTimezone(activity.start, timezone, formatOptions);
            const today = helpers_1.Helpers.convertDateToTimezone(new Date().toString(), timezone, formatOptions);
            let tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            tomorrow = helpers_1.Helpers.convertDateToTimezone(tomorrow.toString(), timezone, formatOptions);
            const isToday = date === today;
            const isTomorrow = date === tomorrow;
            let dayName = helpers_1.Helpers.getWeekdayFromDate(activity.start, timezone);
            if (isToday) {
                dayName = i18n_js_1.default.t('dictionary.dates.today');
            }
            if (isTomorrow) {
                dayName = i18n_js_1.default.t('dictionary.dates.tomorrow');
            }
            const monthName = helpers_1.Helpers.convertDateToTimezone(activity.start, timezone, {
                month: 'long',
            });
            const currentDate = helpers_1.Helpers.convertDateToTimezone(activity.start, timezone, { day: 'numeric' });
            const displayText = currentLocale === 'de'
                ? `${helpers_1.Helpers.capitalizeFirstLetter(dayName)}, ${currentDate}. ${helpers_1.Helpers.capitalizeFirstLetter(monthName)}`
                : `${helpers_1.Helpers.capitalizeFirstLetter(dayName)}, ${helpers_1.Helpers.capitalizeFirstLetter(monthName)} ${currentDate}`;
            if (!daysDisplayed.includes(displayText)) {
                daysDisplayed.push(displayText);
                groupedActivities.push({
                    isDateTitle: true,
                    displayText,
                    start: activity.start,
                    groupNumber: daysDisplayed.length - 1,
                    videos: [],
                });
            }
            groupedActivities.push(Object.assign({}, activity, { groupNumber: daysDisplayed.length - 1 }));
            return null;
        });
        return groupedActivities;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !conventionCode && (react_1.default.createElement(Filters, { className: `${isScroll ? 'border-bottom' : ''}` },
            react_1.default.createElement(Box_1.default, { className: "filters-content" },
                filters.length > 0 && (react_1.default.createElement(BubbleFilter_1.BubbleFilter, { filters: filters, selectedFilter: selectedFilter, filterActivitiesByInterest: newFilter => {
                        onFilterSelect(newFilter);
                    } })),
                react_1.default.createElement(DateFilter_1.default, { filterActivitiesByDate: () => { }, newActivitiesDateUpdate: newDateFilter => {
                        if (newDateFilter === null) {
                            onDateFilterSelect(null);
                            return;
                        }
                        onDateFilterSelect(newDateFilter.date);
                    }, numberOfDays: numberOfDaysToBeDisplayed, userScrolledToDate: () => { }, setUserScrolledToDate: () => { } })))),
        react_1.default.createElement(ActivityListWrapper, null,
            react_1.default.createElement(ActivityListContainer, { contentMaxWidth: globalVariables_1.WEB_APP.MAX_WIDTH_CONTAINER },
                !isLoading && filteredActivitiesWithDateTitles.length > 0 && buildRows(filteredActivitiesWithDateTitles),
                isLoading && (react_1.default.createElement(LoaderWrapper, { className: "loader-wrapper" },
                    react_1.default.createElement(Loader_1.default, null))),
                noActivitiesAtAll && (react_1.default.createElement(NoActivitiesWrapper, null,
                    react_1.default.createElement(DateRange_1.default, { className: "date-icon" }),
                    react_1.default.createElement("p", null,
                        " ",
                        i18n_js_1.default.t('daily_view_no_more_activities'),
                        " "))),
                noFilteredActivities && (react_1.default.createElement(NoActivitiesWrapper, null,
                    react_1.default.createElement(DateRange_1.default, { className: "date-icon" }),
                    react_1.default.createElement("p", null,
                        " ",
                        i18n_js_1.default.t('no_activities_found_activity_list'),
                        " "))),
                !isLoading && filteredActivitiesWithDateTitles.length !== 0 && (react_1.default.createElement(PaginationWrapper, null,
                    react_1.default.createElement(Pagination_1.default, { page: currentPage + 1, count: Math.ceil(filteredTotal / BATCH_SIZE), color: "primary", onChange: (evt, page) => {
                            setCurrentPage(page - 1);
                        } })))))));
};
const mapStoreToProps = store => ({
    baseUrl: store.getValue('baseUrl'),
    activities: store.getValue('unfilteredActivities'),
    activitiesWereFetched: store.getValue('activitiesWereFetched'),
    filters: store.getValue('bubbleFilters'),
    timezone: store.getValue('timezone'),
    currentLocale: store.getValue('currentLocale'),
    userData: store.getValue('userData'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(Activities));
